export const ADMIN = {
  GET_ROLE: "GetCurrentRolePermissions",
  GET_COUNTRIES: "getCountries",
  GET_COUNTRY_DETAILS: "getCountryDetails",
  GET_STATE_DETAILS: "getStateDetails",
  GET_CITIES_OF_COUNTRY: "getCitiesOfCountry",
  GET_INAPPROPRIATE_WORDS: "getInappropriateWords",
};
export const PUBLIC = { PRIVACY: "PublicPrivacy" };
